query MfaSessions(
	$offset: Int!
	$limit: Int!
	$sort: mfa_session_runsSort
	$textSearch: mfa_session_runsSearchInsensitive
	$textSearchExact: mfa_session_runsSearchInsensitive
	$daysAmountFilter: ConditionInt
	$createdByFilter: ConditionString
	$customFieldsFilter: ConditionStringArray
	$osFilter: ConditionStringArray
	$appFilter: ConditionStringArray
	$appVersionFilter: ConditionStringArray
	$severityOrFilter: [mfa_session_runsOrFilter!]
) {
	mfa_session_runs(
		offset: $offset
		limit: $limit
		sort: $sort
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $osFilter
		app_eq_any_item_for_any_value: $appFilter
		app_version_eq_any_item_for_any_value: $appVersionFilter
		or: $severityOrFilter
	) {
		run_id
		session_name
		total_scans
		total_issues
		critical_issues
		serious_issues
		moderate_issues
		minor_issues
		best_practice_issues
		needs_review_issues
		run_updated_at
		user_name
		custom_fields
        device_manufacturer
        device_model
        device_type
        os
        os_version
        app_id
        mobile_kit
        app_version
        app_build_number
        app
        product_version
		os
	}
	total: mfa_session_runs(
		text_contains: $textSearch
		text_equals: $textSearchExact
		run_time_last_n_days: $daysAmountFilter
		user_name_eq: $createdByFilter
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq_any_item_for_any_value: $osFilter
		app_eq_any_item_for_any_value: $appFilter
		app_version_eq_any_item_for_any_value: $appVersionFilter
		or: $severityOrFilter
	) {
		run_id_count
	}
	unfiltered_total: mfa_session_runs {
		run_id_count
	}
}
